import { render, staticRenderFns } from "./Breeds.vue?vue&type=template&id=b53781c6&scoped=true&lang=pug&"
import script from "./Breeds.vue?vue&type=script&lang=js&"
export * from "./Breeds.vue?vue&type=script&lang=js&"
import style0 from "./Breeds.vue?vue&type=style&index=0&id=b53781c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53781c6",
  null
  
)

export default component.exports